webpackJsonp([35783957827783],{

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(47);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Logo = __webpack_require__(40);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import cover from './../assets/images/made-in-italy.jpg'
	var Banner = function Banner(props) {
	    return _react2.default.createElement(
	        'section',
	        { id: 'banner', style: {
	                backgroundImage: 'url(' + props.cover.sizes.originalImg + ')',
	                textAlign: 'center'
	            } },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(_Logo2.default, null)
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(47);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import pic01 from '../assets/images/bg_1.jpg'
	
	var Block = function Block(props) {
	    return _react2.default.createElement(
	        'article',
	        { className: 'block' },
	        _react2.default.createElement(
	            'div',
	            { className: 'block__top' },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: props.img.sizes, alt: props.title })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'block__copy sha' },
	            _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            props.title
	                        )
	                    ),
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: props.copy } })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Block;
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	           return _react2.default.createElement(
	                      "header",
	                      { style: { marginBottom: "12vh", textAlign: "center" } },
	                      _react2.default.createElement(
	                                 "h1",
	                                 { style: { letterSpacing: "-2px", marginBottom: "0", fontSize: "6rem", lineHeight: "5rem" } },
	                                 "LSM"
	                      ),
	                      _react2.default.createElement(
	                                 "h4",
	                                 { className: "f-serif" },
	                                 "MAGLIFICIO"
	                      )
	           );
	};
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "section",
	        { style: { maxWidth: "30rem", margin: "1rem auto 2rem auto" } },
	        _react2.default.createElement(
	            "div",
	            { className: "inner", style: { textAlign: "center", padding: "2em 1em 0em 2em" } },
	            _react2.default.createElement(
	                "header",
	                { className: "" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "PITTI IMMAGINE FILATI"
	                )
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Puoi trovare le nostre creazioni all'interno di ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                    "b",
	                    null,
	                    "Pitti Immagine Filati 82"
	                ),
	                _react2.default.createElement("br", null),
	                "24-26 Gennaio 2018",
	                _react2.default.createElement("br", null),
	                "stand Shima Seiki c-18/19",
	                _react2.default.createElement("br", null),
	                "Padiglione Centrale - piano inferiore",
	                _react2.default.createElement("br", null),
	                "Fortezza da Basso - Firenze"
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(52);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(188);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Block = __webpack_require__(71);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _pitti = __webpack_require__(192);
	
	var _pitti2 = _interopRequireDefault(_pitti);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import pic01 from '../assets/images/bg_1.jpg'
	// import pic02 from '../assets/images/bg_2.jpg'
	// import pic03 from '../assets/images/bg_3.jpg'
	// import pic03 from '../assets/images/pic03.jpg'
	// import pic04 from '../assets/images/pic04.jpg'
	// import pic05 from '../assets/images/pic05.jpg'
	// import pic06 from '../assets/images/pic06.jpg'
	
	var HomeIndex = function (_React$Component) {
	    _inherits(HomeIndex, _React$Component);
	
	    function HomeIndex() {
	        _classCallCheck(this, HomeIndex);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    HomeIndex.prototype.render = function render() {
	        var _props$data = this.props.data,
	            site = _props$data.site,
	            cover = _props$data.cover;
	        var _site$siteMetadata = site.siteMetadata,
	            title = _site$siteMetadata.title,
	            description = _site$siteMetadata.description;
	
	        console.log(site);
	
	        // const siteDescription = this.props.data.site.siteMetadata.description
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    title
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: description })
	            ),
	            _react2.default.createElement(_Banner2.default, { cover: cover }),
	            _react2.default.createElement(_pitti2.default, null)
	        );
	    };
	
	    return HomeIndex;
	}(_react2.default.Component);
	
	exports.default = HomeIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ffafba92729c49490cbd.js